module.exports = "/_next/static/images/Customer-Service-bafedc1e5249c3b90908e85d08d655b5.jpg";